import { useState, useCallback } from 'react';

export const useNodeResizing = () => {
  const [resizing, setResizing] = useState(false);

  const setResizeTrue = useCallback(() => {
    setResizing(true);
  }, []);

  const setResizeFalse = useCallback(() => {
    setResizing(false);
  }, []);

  return {
    resizing,
    setResizeTrue,
    setResizeFalse,
  };
};
